// import { fetchToken } from "../../../common/FetchCookie";
// import { SUBSCRIPTION_MANUAL } from "../../../common/URLs";


// export const fetchSubscriptionCustom = async () => {
//   try {
//     const token = await fetchToken()

//     const response = await fetch(SUBSCRIPTION_MANUAL, {
//       method: "GET",headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(
//         errorData.response?.msg || `HTTP error! Status: ${response.status}`
//       );
//     }
//     const data = await response.json();
//     return data.response || [];
//   } catch (error) {
//     console.error("API Error:", error);
//     throw error;
//   }
// };

// export const addSubscriptionCustom = async (newSubscription) => {
//   try {
//         const token = await fetchToken()

//     const response = await fetch(SUBSCRIPTION_MANUAL, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(newSubscription),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(
//         errorData.response?.msg ||
//           `Error adding subscription: ${response.statusText}`
//       );
//     }

//     const data = await response.json();
//     return data.response || data;
//   } catch (error) {
//     console.error("Add error:", error);
//     throw error;
//   }
// };

// export const updateSubscriptionCustom = async (id, updateSubscriptiondata) => {
//   try {
//         const token = await fetchToken()

//     const response = await fetch(`${SUBSCRIPTION_MANUAL}/${id}`, {
//       method: "PUT",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(updateSubscriptiondata),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(
//         errorData.response?.msg || `Error updating: ${response.statusText}`
//       );
//     }

//     const data = await response.json();
//     return data.response || data;
//   } catch (error) {
//     console.error("Update error:", error);
//     throw error;
//   }
// };

// export const deleteSubscriptionCustom = async (id) => {
//   try {
//     const token = await fetchToken()

//     const response = await fetch(`${SUBSCRIPTION_MANUAL}/${id}`, {
//       method: "DELETE",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(
//         errorData.response?.msg || `Error deleting: ${response.statusText}`
//       );
//     }

//     return { success: true, id };
//   } catch (error) {
//     console.error("Delete error:", error);
//     throw error;
//   }
// };



import { fetchToken } from "../../../common/FetchCookie"
import { SUBSCRIPTION_MANUAL } from "../../../common/URLs"

export const fetchSubscriptionCustom = async () => {
  try {
    const token = await fetchToken()
    const response = await fetch(SUBSCRIPTION_MANUAL, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `HTTP error! Status: ${response.status}`)
    }
    const data = await response.json()
    return data.response || []
  } catch (error) {
    console.error("API Error:", error)
    throw error
  }
}

export const addSubscriptionCustom = async (newSubscription) => {
  try {
    const token = await fetchToken()
    const response = await fetch(SUBSCRIPTION_MANUAL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newSubscription),
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `Error adding subscription: ${response.statusText}`)
    }
    const data = await response.json()
    return data.response || data
  } catch (error) {
    console.error("Add error:", error)
    throw error
  }
}

export const updateSubscriptionCustom = async (id, updateSubscriptiondata) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${SUBSCRIPTION_MANUAL}/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateSubscriptiondata),
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `Error updating: ${response.statusText}`)
    }
    const data = await response.json()
    return data.response || data
  } catch (error) {
    console.error("Update error:", error)
    throw error
  }
}

export const deleteSubscriptionCustom = async (id) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${SUBSCRIPTION_MANUAL}/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `Error deleting: ${response.statusText}`)
    }
    return { success: true, id }
  } catch (error) {
    console.error("Delete error:", error)
    throw error
  }
}
